import React from "react";
import { Paper, Skeleton } from "@mui/material";

const ICON_SIZE = 50;

/**
 * KPI card matching the Overview dashboard cards (modules/dashboard/index.jsx):
 * label on top, value beside a 50px icon, optional subtitle underneath.
 * The subtitle sits below the value/icon row so values line up across cards
 * whether or not a card has one.
 *
 * `icon` is an image src or a React node (rendered in a 50px box).
 */
const AppStatCard = ({ title, value, subtitle, icon, action, isLoading = false }) => {
  return (
    <Paper className="p-3 bg-white h-100">
      <div className="d-flex justify-content-between align-items-start gap-2 mb-3">
        <div>{title}</div>
        {action}
      </div>
      <div className="d-flex justify-content-between align-items-end gap-2">
        <div className="fs-4 fw-medium text-break" style={{ minWidth: 0 }}>
          {isLoading ? <Skeleton width={120} /> : value}
        </div>
        {icon && (
          <div className="flex-shrink-0" style={{ width: ICON_SIZE, height: ICON_SIZE }}>
            {typeof icon === "string" ? (
              // Inline size: the global `img { width: auto; height: auto }` in index.css overrides
              // width/height attributes, so SVGs with different intrinsic sizes (40px vs 60px) would differ.
              <img src={icon} alt={title} style={{ width: ICON_SIZE, height: ICON_SIZE }} />
            ) : (
              icon
            )}
          </div>
        )}
      </div>
      {subtitle && <div className="fs-sm text-secondary mt-1">{subtitle}</div>}
    </Paper>
  );
};

export default AppStatCard;
